/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   getHasMessaged
 */

import type { BuildingListingCollection } from '@zcode/bizos'
import { localStorageSingleton } from '@zcode/nr-utils'
import { oisEmpty } from '@zcode/nr/es/shared/utils/utils'

export const getHasMessaged = () => {
  const localMessaged: BuildingListingCollection | undefined = localStorageSingleton.get('messaged')
  const { listings, buildings } = localMessaged || {}
  return !oisEmpty(listings) || !oisEmpty(buildings)
}
